import React from "react";
import Slider from "react-slick";
import "../styles/ReviewPage.css";
import ProfileIcon from "../assets/profileicon.png";

const reviews = [
  {
    text: "This AI image generator is a game-changer! I can't believe how realistic and stunning the images are. It's like having a personal artist at my fingertips.",
    user: "Mark Johnson",
    designation: "UI/UX Designer at Web Experts",
  },
  {
    text: "I've been experimenting with different styles and concepts, and the results are always impressive. The tool is easy to use and offers endless creative opportunities.",
    user: "Ennifer Patel",
    designation: "Marketing Manager at Small Business",
  },
  {
    text: "I used to spend hours searching for the perfect image. Now, I can generate exactly what I need in seconds. This tool has saved me so much time and effort.",
    user: "Lisa Brown",
    designation: "Art Director at Advertising Agency",
  },
  {
    text: "The image quality is good, but sometimes the details can be a bit blurry. I hope future updates address this issue.",
    user: "David Kim",
    designation: "Content Creator at Social Media Buzz",
  },
  {
    text: "I've always wanted to create art but lacked the skills. This AI tool has helped me bring my imagination to life. It's incredibly inspiring!",
    user: "Sarah Lee",
    designation: "Graphic Designer at Creative Designs Inc.",
  },
  {
    text: "While the tool is versatile, I'd love to see more art styles available. More options would make it even better.",
    user: "Alex Turner",
    designation: "Digital Marketing Manager at TechNova",
  },
];

const ReviewPage = () => {
  const settings = {
    dots: false, // Show navigation dots
    infinite: true, // Infinite looping
    speed: 500, // Transition speed
    slidesToShow: 2, // Show 2 reviews at a time
    slidesToScroll: 2, // Move 2 reviews at a time
    autoplay: true, // Auto move forward
    autoplaySpeed: 3000, // 3 seconds
    arrows: false, // Hide navigation arrows
    vertical: false, // Ensures horizontal scrolling
  };

  return (
    <div className="feature-page">
      <div className="review-header">
        <div className="line-image"></div>
        <h1 className="review-title">Review</h1>
        <div className="line-image"></div>
      </div>
      <h2 className="feature-heading1">
        Check Out What The Creatives <br /> Are Saying About Us
      </h2>
      <div className="reviews-container">
        <Slider {...settings}>
          {reviews.map((review, index) => (
            <div key={index} className="review-box">
              <p className="review-text">{review.text}</p>
              <div className="review-footer">
                <img src={ProfileIcon} alt="User Icon" className="user-icon" />
                <div className="user-info">
                  <p className="review-user">{review.user}</p>
                  <p className="review-designation">{review.designation}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ReviewPage;
